/**
 * KÖRVONAL — cutoff-countdown-v1 (see snippets/korvonal-cutoff.liquid for the
 * full contract: states, modes, measurement, and where 14:00 / +2 business
 * days come from).
 *
 * Loaded only when the snippet's gates pass (mode != off, HU market). This
 * file adds the HUF gate, resolves the arm, and drives all three states from
 * a 1-second tick. The tick doubles as the re-mount loop: the cart drawer's
 * #AjaxCartSubtotal is innerHTML-replaced on every cart change, so instead of
 * observer bookkeeping the tick simply re-inserts the cart line whenever it
 * finds an anchor without one.
 */
(function () {
  'use strict';

  var cfg = document.getElementById('kv-cutoff-config');
  if (!cfg) return;

  var MODE = cfg.getAttribute('data-mode');
  var IS_PDP = cfg.getAttribute('data-pdp') === '1';
  var PDP_AVAILABLE = cfg.getAttribute('data-available') === '1';
  var FS_RAW = parseInt(cfg.getAttribute('data-fs') || '', 10);
  // Christmas gift-card swap (see the snippet header). Its own preview key,
  // shared with assets/korvonal-gc-placement.js.
  var GC_URL = cfg.getAttribute('data-gc-url') || '';
  var GC_ID = cfg.getAttribute('data-gc-id') || '';
  var GC_ON = false;
  // Sold-out line (see the snippet header): its own switch, same preview key.
  var GC_SOLDOUT_ON = false;
  try {
    var gp = new URLSearchParams(window.location.search).get('gc_preview');
    if (gp === '0' || gp === 'off') sessionStorage.removeItem('kvgc_prev');
    else if (gp) sessionStorage.setItem('kvgc_prev', '1');
    var gprev = sessionStorage.getItem('kvgc_prev') === '1';
    var gm = cfg.getAttribute('data-gc');
    GC_ON = !!GC_URL && (gm === 'on' || (gm === 'preview' && gprev));
    var gs = cfg.getAttribute('data-gc-soldout');
    GC_SOLDOUT_ON = !!GC_URL && (gs === 'on' || (gs === 'preview' && gprev));
  } catch (e) {
    GC_ON = !!GC_URL && cfg.getAttribute('data-gc') === 'on';
    GC_SOLDOUT_ON = !!GC_URL && cfg.getAttribute('data-gc-soldout') === 'on';
  }

  var KEY = 'cutoff-countdown-v1';
  var TOKEN = 'cmpismusd0000b965jxyb4r46'; // same storefront-events token the theme already embeds
  var ENDPOINT = 'https://api.korvonal.com/api/storefront-events/' + TOKEN;

  var CUTOFF_HOUR = 14; // Budapest — see the snippet header for the evidence
  // Dispatch + 1 business day is the carrier median but only ~65-75% certain
  // for home delivery (GLS 75% / DPD 52%; +2 would be ~90%). Operator call
  // (2026-08-25): name the median day, softened with "várhatóan" in every
  // surface, instead of the conservative firm +2.
  var SLA_BUSINESS_DAYS = 1;

  // Hungarian public holidays + decreed rest days (pihenőnap: 2026-01-02,
  // 2026-08-21, 2026-12-24 — the Dec 24 that pairs with the Dec 12 working
  // Saturday). REFRESH YEARLY from the official munkanap-áthelyezés decree.
  // 2027 has no holiday on Tue/Thu, so no moves are expected; re-check when
  // the decree lands (usually each autumn).
  var HOLIDAYS = {
    '2026-08-21': 1,
    '2026-10-23': 1, '2026-12-24': 1, '2026-12-25': 1, '2026-12-26': 1,
    '2027-01-01': 1, '2027-03-15': 1, '2027-03-26': 1, '2027-03-29': 1,
    '2027-05-01': 1, '2027-05-17': 1, '2027-08-20': 1, '2027-10-23': 1,
    '2027-11-01': 1, '2027-12-24': 1, '2027-12-25': 1, '2027-12-26': 1
  };
  // Makeup working Saturdays (szombati munkanapok) — Webshippy fulfills on
  // these, so they count as dispatch/delivery days. Same yearly refresh.
  var WORKING_SATURDAYS = {
    '2026-01-10': 1, '2026-08-08': 1, '2026-12-12': 1
  };

  // ── Preview plumbing (sticky per session, excluded from bookkeeping) ──────
  var preview = null;
  var mockClock = null;
  try {
    var m = window.location.search.match(/[?&]cutoff=([a-z0-9]+)/);
    if (m) {
      if (m[1] === '0' || m[1] === 'off') sessionStorage.removeItem('kvco_prev');
      else sessionStorage.setItem('kvco_prev', m[1] === 'control' ? 'control' : 'treatment');
    }
    var mt = window.location.search.match(/[?&]cutoff_t=([0-9T:-]+)/);
    if (mt) sessionStorage.setItem('kvco_t', mt[1]);
    preview = sessionStorage.getItem('kvco_prev');
    if (preview) mockClock = sessionStorage.getItem('kvco_t'); // preview-only: real visitors never get a mocked clock
  } catch (e) { /* storage blocked: preview simply unavailable */ }

  if (MODE === 'preview' && !preview) return;

  // ── Arm ───────────────────────────────────────────────────────────────────
  var arm;
  var bookkeeping = MODE === 'ab' && !preview;
  if (preview) arm = preview;
  else if (MODE === 'on') arm = 'treatment';
  else if (MODE === 'ab') {
    try {
      arm = localStorage.getItem('kv_cutoff_arm');
      if (arm !== 'control' && arm !== 'treatment') {
        arm = Math.random() < 0.5 ? 'control' : 'treatment';
        localStorage.setItem('kv_cutoff_arm', arm);
      }
    } catch (e) {
      // Storage blocked: unassignable and unmeasurable — stay out of the books.
      return;
    }
  } else return;

  // ── Bookkeeping (same contract as korvonal-consent-exp) ───────────────────
  function visitorId() {
    try {
      var v = localStorage.getItem('otto_visitor_id');
      if (!v) {
        v = window.crypto && crypto.randomUUID ? crypto.randomUUID() : 'v-' + Date.now() + '-' + Math.random().toString(16).slice(2);
        localStorage.setItem('otto_visitor_id', v);
      }
      return v;
    } catch (e) { return null; }
  }

  function track(name, idSuffix) {
    if (!bookkeeping) return;
    var vid = visitorId();
    if (!vid) return;
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({ events: [{
          id: KEY + ':' + vid + (idSuffix ? ':' + idSuffix : ''),
          eventName: name, clientId: vid,
          occurredAt: new Date().toISOString(),
          data: { experimentKey: KEY, variant: arm }
        }] })
      }).catch(function () {});
    } catch (e) { /* bookkeeping must never break the page */ }
  }

  var exposed = false;
  function exposeAndStamp() {
    if (exposed) return;
    exposed = true;
    track('experiment_exposure', ''); // once per visitor (id upserts on the stable vid)
    if (!bookkeeping) return;
    try {
      if (/(^|;\s*)cart=/.test(document.cookie) && !sessionStorage.getItem('kvco_stamped')) {
        sessionStorage.setItem('kvco_stamped', '1');
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { _experiment_cutoff: KEY + ':' + arm } })
        }).catch(function () {
          try { sessionStorage.removeItem('kvco_stamped'); } catch (e) {}
        });
      }
    } catch (e) { /* never block the page on bookkeeping */ }
  }

  // ── Budapest clock + working-day math ─────────────────────────────────────
  // The visitor's clock offset is wrong for a Budapest cutoff, so build a
  // "fake-local" Date carrying Budapest wall time; all math stays in that
  // frame and only differences/weekdays are ever read from it.
  var bpFmt;
  try {
    bpFmt = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Budapest',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    });
  } catch (e) { return; } // no Intl timezone support: better nothing than a wrong promise

  function budapestNow() {
    if (mockClock) {
      var iso = mockClock.indexOf('T') > 0 ? mockClock : ymd(budapestReal()) + 'T' + mockClock;
      var d = new Date(iso);
      if (!isNaN(d)) return d;
    }
    return budapestReal();
  }
  function budapestReal() {
    var parts = bpFmt.formatToParts(new Date());
    var g = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parts[i].value; return '00'; };
    // en-CA gives 24h clock but midnight as "24" in some engines — normalize.
    var h = g('hour') === '24' ? '00' : g('hour');
    return new Date(g('year') + '-' + g('month') + '-' + g('day') + 'T' + h + ':' + g('minute') + ':' + g('second'));
  }
  function ymd(d) {
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
  }
  function isWorkday(d) {
    var dow = d.getDay();
    if (dow === 6) return !!WORKING_SATURDAYS[ymd(d)];
    return dow >= 1 && dow <= 5 && !HOLIDAYS[ymd(d)];
  }
  function addDays(d, n) {
    var r = new Date(d);
    r.setDate(r.getDate() + n);
    return r;
  }
  function nextWorkday(d) {
    var r = addDays(d, 1);
    while (!isWorkday(r)) r = addDays(r, 1);
    return r;
  }
  function addBusinessDays(d, n) {
    var r = new Date(d);
    while (n > 0) { r = nextWorkday(r); n--; }
    return r;
  }

  var DAY_ON = ['vasárnap', 'hétfőn', 'kedden', 'szerdán', 'csütörtökön', 'pénteken', 'szombaton'];
  var DAY_ADJ = ['vasárnapi', 'hétfői', 'keddi', 'szerdai', 'csütörtöki', 'pénteki', 'szombati'];
  var DAY_BY = ['vasárnapra', 'hétfőre', 'keddre', 'szerdára', 'csütörtökre', 'péntekre', 'szombatra'];
  var dateFmt;
  try { dateFmt = new Intl.DateTimeFormat('hu-HU', { month: 'short', day: 'numeric' }); } catch (e) { dateFmt = null; }

  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function withDateIfFar(word, day, now) {
    // Beyond ~5 days (long holiday runs) a bare weekday is ambiguous — pin it.
    var diff = Math.round((new Date(ymd(day)) - new Date(ymd(now))) / 86400000);
    if (diff <= 5 || !dateFmt) return word;
    return word + ' (' + dateFmt.format(day) + ')';
  }
  var DAY_WORDS = {
    on: { list: DAY_ON, tomorrow: 'holnap' },
    adj: { list: DAY_ADJ, tomorrow: 'holnapi' },
    by: { list: DAY_BY, tomorrow: 'holnapra' }
  };
  /**
   * The delivery day in words. When the day IS tomorrow, "holnap" beats the
   * weekday name — operator call 2026-08-26: "csütörtökön" makes the reader
   * work out how far away that is, "holnap" lands on its own. Anything
   * further out keeps the weekday, with the date pinned past ~5 days.
   */
  function dayWord(kind, day, now) {
    var f = DAY_WORDS[kind];
    if (ymd(day) === ymd(addDays(now, 1))) return f.tomorrow;
    return withDateIfFar(f.list[day.getDay()], day, now);
  }
  // "4 óra 32 percen", "16 percen", "1 percen" — minutes always rounded UP so
  // the promise is never tighter than the clock (15:30 left reads "16 percen
  // belül", not 15). The caller appends " belül".
  function fmtRemaining(ms) {
    var totalMin = Math.max(1, Math.ceil(ms / 60000));
    var h = Math.floor(totalMin / 60), m = totalMin % 60;
    if (h > 0 && m > 0) return h + ' óra ' + m + ' percen';
    if (h > 0) return h + ' órán';
    return m + ' percen';
  }
  function fmtFt(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Ft';
  }

  /**
   * The whole widget's truth, recomputed every tick.
   *   countdown: ms to today's cutoff, or null when outside the state-1 window
   *   dispatchDay / deliveryDay: Dates in the Budapest frame
   *   afterCutoffToday: true only in the workday-after-14:00 case (drives the
   *   approved "Ma 14:00 után rendelted?" opener; weekends/holidays get the
   *   plain form because nothing was ordered "after 14:00 today").
   */
  function computeState() {
    var now = budapestNow();
    var cutoff = new Date(now);
    cutoff.setHours(CUTOFF_HOUR, 0, 0, 0);
    var beforeCutoff = isWorkday(now) && now < cutoff;
    var dispatchDay = beforeCutoff ? new Date(now) : nextWorkday(now);
    return {
      now: now,
      countdown: beforeCutoff ? cutoff - now : null,
      dispatchDay: dispatchDay,
      deliveryDay: addBusinessDays(dispatchDay, SLA_BUSINESS_DAYS),
      afterCutoffToday: !beforeCutoff && isWorkday(now) && now >= cutoff
    };
  }

  /**
   * True while the named delivery day misses Christmas: it falls after
   * 24 December and it is still the 24th or earlier. 24 December itself is
   * a rest day in the holiday table, so the last day that counts is the
   * last working day before it. After the 24th the normal line returns.
   */
  function christmasMissed(st) {
    if (!GC_ON) return false;
    var eve = st.now.getFullYear() + '-12-24';
    return ymd(st.now) <= eve && ymd(st.deliveryDay) > eve;
  }

  // A cart of gift cards only ships nothing, so neither the delivery promise
  // nor the gift-card offer applies to it.
  function cartIsGiftCardsOnly() {
    if (!GC_ID) return false;
    var items = document.querySelectorAll('[data-js-cart-item][data-product-id]');
    if (!items.length) return false;
    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute('data-product-id') !== GC_ID) return false;
    }
    return true;
  }

  function gcLink() {
    return '<a href="' + GC_URL + '"><b>Küldj ajándékkártyát</b></a>';
  }
  function gcPdpHtml() {
    return '<span class="kv-cutoff__clock" aria-hidden="true">🎁 </span><span>Nem ér oda karácsonyra? ' +
      gcLink() + ' — azonnal megérkezik.</span>';
  }
  function gcCartHtml() {
    return 'Nem ér oda karácsonyra? ' + gcLink() + ' — azonnal megérkezik.';
  }
  function gcSoldoutHtml() {
    var url = GC_URL.replace('kv_src=cutoff', 'kv_src=soldout');
    return '<span class="kv-cutoff__clock" aria-hidden="true">🎁 </span><span>Ajándékba szánod? ' +
      '<a href="' + url + '"><b>Küldj helyette ajándékkártyát</b></a> — azonnal megérkezik.</span>';
  }

  // ── Rendering ─────────────────────────────────────────────────────────────
  // Deliberately louder than the neutral #f9f9f9 info bubbles (operator ask,
  // 2026-08-25): soft green tint + border from the theme's own dark green.
  var CSS =
    '.kv-cutoff{display:flex;align-items:flex-start;gap:2px;background:#eef4e8;' +
      'border:1px solid rgba(47,75,63,.3);border-radius:30px;' +
      'padding:12px 18px;margin-top:14px;font-size:14px;line-height:1.5;color:#2f3b33;}' +
    '.kv-cutoff__clock{flex-shrink:0;font-size:17px;line-height:1.3;white-space:pre;}' +
    '.kv-cutoff b,.kv-cutoff-cart b{font-variant-numeric:tabular-nums;color:#1e4534;}' +
    // The CART line is deliberately NOT the PDP's pill (operator, 2026-08-29:
    // "make the countdown more lightweight in the drawer, text only, with bold
    // parts"). The drawer already stacks a free-shipping bar, an offer card and
    // the FAQ above the button; a second tinted, bordered capsule in that column
    // reads as a fourth widget rather than a line of information. Plain text
    // carries the same sentence at a fraction of the visual weight, and the two
    // bold spans do the emphasis the box used to do.
    // Sized and toned to the theme's own `.cart__shipping` line directly above
    // it ("Tartalmazza az áfát…"): both are 13px/18.2px, and that line renders
    // at 62% opacity. Matching the tone is what actually unifies them — the
    // sizes were already identical, and full-strength text next to a faded
    // sibling is what read as a size difference. The bold stays at full
    // strength so the one number on the line still carries.
    '.kv-cutoff-cart{display:block;text-align:left;font-size:13px;line-height:1.4;' +
      'margin:0 0 10px;color:rgba(48,48,48,.62);}' +
    '.kv-cutoff-cart b{font-weight:600;color:#1e4534;}' +
    '.kv-cutoff a,.kv-cutoff-cart a{color:inherit;text-decoration:underline;text-underline-offset:2px;}';

  function injectCss() {
    if (document.getElementById('kv-cutoff-css')) return;
    var st = document.createElement('style');
    st.id = 'kv-cutoff-css';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  // "házhozszállítással" is load-bearing: csomagpont/locker delivery is
  // measurably slower (Foxpost 63% next-day vs GLS 75%), so the named day is
  // only promised for home delivery — never imply parity (operator, 2026-08-25).
  function pdpHtml(st) {
    if (st.countdown != null) {
      // Inez's wording (operator, 2026-09-05): the BY form of the day plus
      // "lesz" — "holnapra nálad lesz", not "holnap nálad". It reads as a
      // consequence of ordering in time ("igy"), which is what the countdown is
      // for, and the by-form is the same promise the post-cutoff branch below
      // already makes. "varhatoan" stays: the day is a median, not a guarantee.
      // Linda's wording, approved by the operator 2026-09-29: home delivery
      // named up front, "már" + the ON form of the day, free shipping as its
      // own sentence. The pv-sg promise block parses this line (kv-sg-transform
      // dayFrom), so change both together.
      var deliver = dayWord('on', st.deliveryDay, st.now);
      var fs = FS_RAW > 0 ? ' ' + fmtFt(FS_RAW) + ' feletti rendelés esetén a kiszállítás ingyenes.' : '';
      return '<span class="kv-cutoff__clock" aria-hidden="true">⏱️ </span><span>Rendeld meg <b>' +
        fmtRemaining(st.countdown) + ' belül</b> házhozszállítással, és várhatóan már <b>' + deliver +
        ' nálad lesz</b>.' + fs + '</span>';
    }
    // Post-cutoff on a workday: Webshippy processes until 17:00, so same-day
    // dispatch is still possible (28% in the 14h hour) — "ma vagy holnap" is
    // the honest phrasing. The named day stays the conservative next-dispatch
    // + SLA computation, with the by-day suffix ("péntekre" = by Friday).
    var deliverBy = dayWord('by', st.deliveryDay, st.now);
    var dispatchIsTomorrow = ymd(st.dispatchDay) === ymd(addDays(st.now, 1));
    var dispatchWord;
    if (st.afterCutoffToday && st.now.getHours() < 17) {
      // Webshippy processes until 17:00, so between the 14:00 cutoff and
      // 17:00 same-day dispatch is still live — "Ma vagy holnap" is honest.
      // After 17:00 the "ma" would be false, so the plain "Holnap" branch
      // below takes over (operator rule, 2026-08-25).
      // Friday (or pre-holiday) evening: "holnap" would name a non-working
      // day, so fall back to the dispatch day's name ("Ma vagy hétfőn").
      dispatchWord = 'Ma vagy ' + (dispatchIsTomorrow ? 'holnap' : DAY_ON[st.dispatchDay.getDay()]);
    } else {
      dispatchWord = dispatchIsTomorrow ? 'Holnap' : cap(DAY_ON[st.dispatchDay.getDay()]);
    }
    // Same shape as the countdown branch above (Inez, via operator 2026-09-05):
    // "igy varhatoan <day> nalad lesz, hazhozszallitassal". The two states sit
    // in the same slot on the same page, so a shopper who reloads across 14:00
    // should not see the sentence restructure itself.
    return '<span class="kv-cutoff__clock" aria-hidden="true">📦 </span><span>' +
      dispatchWord + ' adjuk fel — így várhatóan <b>' + deliverBy +
      ' nálad lesz</b>, házhozszállítással.</span>';
  }

  function cartHtml(st) {
    // Same sentence as the PDP and the locator (operator, 2026-09-05), so the
    // promise does not re-word itself as a shopper moves product -> cart. Keeps
    // the BY day form rather than the adjectival one the old phrasing needed.
    //
    // Still no clock emoji, unlike the PDP: without the capsule behind it the
    // glyph is the only ornament left on the line and it reads as decoration.
    // No free-shipping tail either — the subtotal it sits under already says it.
    //
    // "hazhozszallitassal" is as load-bearing here as on the PDP: the shipping
    // method is chosen at checkout, AFTER this line, so a shopper heading for a
    // csomagpont must not read the named day as applying to them.
    var deliver = dayWord('on', st.deliveryDay, st.now);
    return 'Rendeld meg <b>' + fmtRemaining(st.countdown) + ' belül</b> házhozszállítással, és várhatóan már <b>' +
      deliver + ' nálad lesz</b>.';
  }

  function atcDisabled() {
    var btn = document.querySelector('.product-actions form[action*="/cart/add"] [name="add"]');
    return btn ? btn.disabled : false;
  }

  function tick() {
    var st = computeState();
    var render = arm === 'treatment';

    // PDP line — mounted once after .product-actions, then text-updated.
    if (IS_PDP && PDP_AVAILABLE) {
      var actions = document.querySelector('.product-text .product-actions') ||
                    document.querySelector('.product-actions');
      if (actions && !atcDisabled()) {
        exposeAndStamp();
        if (render) {
          var el = document.getElementById('kv-cutoff-pdp');
          if (!el) {
            injectCss();
            el = document.createElement('div');
            el.id = 'kv-cutoff-pdp';
            el.className = 'kv-cutoff';
            actions.insertAdjacentElement('afterend', el);
          }
          var html = christmasMissed(st) ? gcPdpHtml() : pdpHtml(st);
          if (el.getAttribute('data-html') !== html) {
            el.setAttribute('data-html', html);
            el.innerHTML = html;
          }
          // The trust list's seasonal gift-card row (korvonal-pdp-trust.liquid)
          // steps aside while the swap offers the card, so one line offers it.
          var gcRow = document.querySelector('[data-kv-gc-line]');
          if (gcRow) gcRow.style.display = christmasMissed(st) ? 'none' : '';
        }
      }
    } else if (IS_PDP && !PDP_AVAILABLE && GC_SOLDOUT_ON && !document.getElementById('kv-cutoff-pdp')) {
      // Sold-out product: the gift-card offer in the delivery line's place.
      var soldActions = document.querySelector('.product-text .product-actions') ||
                        document.querySelector('.product-actions');
      if (soldActions) {
        injectCss();
        var sold = document.createElement('div');
        sold.id = 'kv-cutoff-pdp';
        sold.className = 'kv-cutoff';
        sold.innerHTML = gcSoldoutHtml();
        soldActions.insertAdjacentElement('afterend', sold);
      }
    }

    // "Hol kapható" line — the locator page's own-shop card, which ships an
    // empty mount point for us. Deliberately NOT wrapped in exposeAndStamp:
    // the experiment's denominator is defined as available-product PDPs and
    // non-empty carts, and counting a third surface into it would quietly
    // move the historical rate. We also publish the state, because the card's
    // headline promises "holnapra kiküldjük" and has to stop doing that
    // outside the before-cutoff window — same rule as the line itself.
    var where = document.getElementById('kv-cutoff-where');
    if (where && render) {
      injectCss();
      // Same Christmas swap as the product page: after the last delivery day
      // before the 24th, the own-shop card offers the gift card, not a date.
      var whtml = christmasMissed(st) ? gcPdpHtml() : pdpHtml(st);
      if (where.getAttribute('data-html') !== whtml) {
        where.setAttribute('data-html', whtml);
        where.innerHTML = whtml;
      }
      var wstate = st.countdown != null ? 'open' : 'closed';
      if (where.getAttribute('data-kvco-state') !== wstate) {
        where.setAttribute('data-kvco-state', wstate);
      }
    }

    // Cart line — the subtotal block is innerHTML-replaced on every cart
    // change, which silently deletes our node; re-inserting from the tick is
    // the whole re-mount strategy. Both the drawer and the /cart page render
    // an #AjaxCartSubtotal (duplicate ids on /cart), so walk all of them.
    var subs = document.querySelectorAll('[id="AjaxCartSubtotal"]');
    var gcSwap = christmasMissed(st);
    var gcOnly = cartIsGiftCardsOnly();
    for (var i = 0; i < subs.length; i++) {
      var sub = subs[i];
      if (sub.querySelector('.cart--empty')) continue;
      var btn = sub.querySelector('[id="CheckOut"]');
      if (!btn) continue;
      exposeAndStamp();
      var line = sub.querySelector('.kv-cutoff-cart');
      if (!render || gcOnly || (st.countdown == null && !gcSwap)) {
        if (line) line.remove();
        continue;
      }
      if (!line) {
        injectCss();
        line = document.createElement('span');
        line.className = 'kv-cutoff-cart';
        btn.parentElement.parentElement.insertBefore(line, btn.parentElement);
      }
      var chtml = gcSwap ? gcCartHtml() : cartHtml(st);
      if (line.getAttribute('data-html') !== chtml) {
        line.setAttribute('data-html', chtml);
        line.innerHTML = chtml;
      }
    }
  }

  function boot() {
    // HUF gate — Shopify.currency is not populated at parse time, but is by
    // DOMContentLoaded (same lesson as korvonal-consent-exp, live 2026-08-16).
    if (!(window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'HUF')) return;
    tick();
    setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
